module.exports = __webpack_public_path__ + "static/media/30.1d931399.JPG";